import { string } from 'prop-types';
import React from 'react';
import AbtraEditorContentDisplay from './AbtraEditorContentDisplay';

function ProductDescription({ descriptionHtml }) {
    return (
        <AbtraEditorContentDisplay
            htmlContent={descriptionHtml}
        />
    );
}

ProductDescription.propTypes = {
    descriptionHtml: string,
};

export default ProductDescription;